'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dProxies$0024$0024anon$00242 from "./presto.-Proxies$$anon$2.js";
import * as $j_presto$002etypes$0024$002dProxy$002dName$0024 from "./presto.types$-Proxy-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_Proxies$$anon$1(outer) {
  this.bpQ = null;
  this.bpO = null;
  this.bpP = false;
  this.bpM = null;
  this.bpN = false;
  this.bpR = false;
  this.bpS = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bpQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_Proxies$$anon$1 as $c_Lpresto_Proxies$$anon$1 };
$p = $c_Lpresto_Proxies$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Proxies$$anon$1;
/** @constructor */
function $h_Lpresto_Proxies$$anon$1() {
}
export { $h_Lpresto_Proxies$$anon$1 as $h_Lpresto_Proxies$$anon$1 };
$h_Lpresto_Proxies$$anon$1.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bpQ;
});
$p.t = (function() {
  if ((!this.bpP)) {
    this.bpO = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ip", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bpP = true;
  }
  return this.bpO;
});
$p.ad = (function() {
  if ((!this.bpN)) {
    this.bpM = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dProxies$0024$0024anon$00242.$c_Lpresto_Proxies$$anon$2(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24($j_presto$002etypes$0024$002dProxy$002dName$0024.$m_Lpresto_types$ProxyName$().crD()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bpN = true;
  }
  return this.bpM;
});
$p.v = (function() {
  if ((!this.bpS)) {
    this.bpR = false;
    this.bpS = true;
  }
  return this.bpR;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_Proxies$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Proxies$$anon$1, "presto.Proxies$$anon$1", ({
  Px: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_Proxies$$anon$1 as $d_Lpresto_Proxies$$anon$1 };
//# sourceMappingURL=presto.-Proxies$$anon$1.js.map
